import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import { addPath } from '../../../actions/JourneyBuilder';
import AddPathComponent, { styles } from './AddPathComponent';

export default compose(
  connect(
    null,
    dispatch => ({
      addPathDispatch() {
        dispatch(addPath());
      },
    })
  ),
  withStyles(styles),
  injectIntl
)(AddPathComponent);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/AddPath.js